import React, { useState } from 'react';
import { createForm } from 'rc-form';
import { Boxed } from '../../../components/Boxed.components';
import { StepList } from '../../../components/FormBuilder.components';
import { Text } from '../../../components/Text.components';
import { AsyncSelect } from '../../../components/Input.components';
import { components } from 'react-select';
import { Avatar } from '../../../components/Avatar.components';
import { Grid } from '../../../components/Grid.components';
import { Theme } from '../../../utils/theme';

const CustomUserOption = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <Avatar size={'24px'} src={data?.extra?.profilePictureUrl ?? ''} name={data?.label} />
    </components.Option>
  );
};

const CustomMultiValueLabel = (props) => {
  const { data } = props;
  return (
    <components.MultiValueLabel {...props}>
      <Avatar size={'24px'} src={data?.extra?.profilePictureUrl ?? ''} name={data?.label} />
    </components.MultiValueLabel>
  );
};

const FormSettings = (props) => {
  // console.log(props);
  const {
    allUsers,
    allSteps,
    updateStep,
    form: { getFieldProps, resetFields }
  } = props;

  const [currentStep, setCurrentStep] = useState(1);

  const addReviewer = (val) => {
    const newState = allSteps.map((obj) => {
      if (obj.id === currentStep) {
        return { ...obj, reviewers: [...val] };
      }
      return obj;
    });
    updateStep(newState);
  };

  const activeStep = allSteps.find((item) => item?.id === currentStep) ?? {};

  return (
    <Grid desktop="160px auto" tablet="160px auto" mobile="repeat(1fr, 1)">
      <StepList
        setCurrentStep={setCurrentStep}
        updateStep={updateStep}
        resetFields={resetFields}
        allSteps={allSteps}
        activeStep={activeStep}
      />
      <Boxed
        bColor={Theme.TertiaryDark}
        borderRadius={Theme.PrimaryRadius}
        margin="12px 16px"
        pad="16px"
      >
        <Boxed>
          <Boxed margin="12px 0">
            <AsyncSelect
              label="Select Default Reviewers"
              isMulti
              placeholder="Default Reviewers"
              options={allUsers?.map((item) => ({
                label: `${item?.lastName} ${item?.firstName}`,
                value: item._id,
                extra: item
              }))}
              components={{
                Option: CustomUserOption,
                MultiValueLabel: CustomMultiValueLabel
              }}
              {...getFieldProps('defaultReviewers', {
                initialValue: activeStep?.reviewers ?? [],
                rules: [],
                onChange: (val) => addReviewer(val)
              })}
              height="auto"
            />
          </Boxed>

          <Boxed margin="12px 0">
            <Text fontWeight={600} margin="0 0 6px 0" fontSize="14px">
              Criteria for Acceptance
            </Text>
            <Boxed margin="0 0 8px 0" display="flex" alignItems="center">
              <Text>This Step will require a mininum of</Text>
              <input
                type="text"
                style={{
                  border: '1px solid #ccc',
                  width: '35px',
                  margin: '0 5px',
                  textAlign: 'center'
                }}
                value={activeStep?.defaultCriteria ?? 0}
                onChange={(e) => {
                  const newState = allSteps.map((obj) => {
                    if (obj.id === currentStep) {
                      return { ...obj, defaultCriteria: e.target.value };
                    }
                    return obj;
                  });
                  updateStep(newState);
                }}
              />
              <Text>approvals from the default reviewers.</Text>
            </Boxed>

            <Boxed display="flex" alignItems="center">
              <Text>This Step will require a mininum of</Text>
              <input
                type="text"
                style={{
                  border: '1px solid #ccc',
                  width: '35px',
                  margin: '0 5px',
                  textAlign: 'center'
                }}
                value={activeStep?.additionalCriteria ?? 0}
                onChange={(e) => {
                  const newState = allSteps.map((obj) => {
                    if (obj.id === currentStep) {
                      return { ...obj, additionalCriteria: e.target.value };
                    }
                    return obj;
                  });
                  updateStep(newState);
                }}
              />
              <Text>approvals from the additional reviewers.</Text>
            </Boxed>
          </Boxed>
        </Boxed>
      </Boxed>
    </Grid>
  );
};

export default createForm()(FormSettings);
